<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="preload" active>
      <a-form :form="form" @submit="handleSubmit">
        <a-tabs default-active-key="general-info">

          <a-tab-pane key="general-info">
            <span slot="tab">
              <a-icon type="container" />
              General Information
            </span>

            <a-divider dashed orientation="left">General Information</a-divider>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: layout.wrapper }" label="Name">
              <a-input placeholder="Name" v-decorator="['name', { rules: [{ required: true }] }]">
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)" />
              </a-input>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Phone">
              <a-input placeholder="Phone" v-decorator="['phone_number', { rules: [{ required: true }] }]">
                <a-icon slot="prefix" type="phone" style="color: rgba(0,0,0,0.25)" />
              </a-input>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Email">
              <a-input placeholder="Email" type="email" v-decorator="['email', { rules: [{ required: true }] }]">
                <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,0.25)" />
              </a-input>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Role"
              validate-status="error" help="ketikan nama role" v-if="!fromProfileMenu">
              <role-autocomplete :current-value="item.role ? item.role : undefined"
                v-decorator="['role', { rules: [{ required: true }] }]"
                @change="handleRoleSelected"></role-autocomplete>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Branch"
              validate-status="error" help="ketikan kode cabang / nama cabang" v-if="!fromProfileMenu">
              <branch-autocomplete :current-value="item.branch ? item.branch.name : undefined"
                @change="handleBranchSelected"></branch-autocomplete>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 7 }" label="Status"
              v-if="editing && item.status != 'blocked' && !fromProfileMenu">
              <a-switch checked-children="Active" un-checked-children="Inactive" default-un-checked
                v-decorator="['status', { valuePropName: 'checked' }]" />
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 12, offset: layout.label }">
              <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit</a-button>
            </a-form-item>
          </a-tab-pane>

          <a-tab-pane key="credential">
            <span slot="tab">
              <a-icon type="key" />
              Credentials
            </span>
            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 6 }" label="Username">
              <a-input placeholder="Username" v-decorator="['username', { rules: [{ required: true }] }]"
                :disabled="editing">
                <a-icon slot="prefix" type="safety" style="color: rgba(0,0,0,0.25)" />
              </a-input>
            </a-form-item>

            <a-form-item :label-col="{ span: layout.label }" :wrapper-col="{ span: 6 }" label="Password"
              v-if="hasPassword">
              <a-input-password placeholder="Password" type="password" v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: false
                    },
                    {
                      min: 8
                    }
                  ]
                }
              ]">
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,0.25)" />
              </a-input-password>
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 6, offset: layout.label }" v-if="hasPassword">
              <a-input-password placeholder="Password Confirmation" type="password" v-decorator="[
                'password_confirmation',
                {
                  rules: [
                    {
                      required: false
                    },
                    {
                      min: 8
                    }
                  ]
                }
              ]">
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,0.25)" />
              </a-input-password>
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 12, offset: layout.label }">
              <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit</a-button>
            </a-form-item>
          </a-tab-pane>

        </a-tabs>
      </a-form>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  props: {
    layout: {
      type: Object,
      default: function () {
        return {
          label: 4,
          wrapper: 7
        }
      }
    },
    user_hash: {
      type: String,
      default: ''
    },
    with_password: {
      type: String,
      default: ''
    },
    from_profile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    editing() {
      return this.user_hash !== ''
    },
    hasPassword() {
      return this.with_password !== ''
    },
    fromProfileMenu() {
      return this.from_profile
    }
  },
  data() {
    return {
      preload: false,
      processing: false,
      item: {},
      branch: undefined,
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  created() {
    if (this.editing) {
      this.preload = true
      this.getItem()
    }
  },
  methods: {
    handleBranchSelected(branch) {
      this.branch = branch.id
    },
    handleRoleSelected(role) {
      this.role = role.id
    },
    getItem() {
      this.$http.get(this.routeUri('hyperion.user.show', { user_hash: this.user_hash }))
        .then(res => (this.item = res.data))
        .finally(() => this.preload = false)
    },
    handleSubmit(e) {
      e.preventDefault(e)

      this.form.validateFields((err, formData) => {
        if (!err) {
          this.processing = true

          let promise

          if (this.branch) {
            formData.branch_code = this.branch
          }

          if (this.role) {
            formData.role = this.role
          }

          if (
            (formData.role == 1 ||
              formData.role == 2) &&
            formData.branch_code !== '100'
          ) {
            this.$notification.error({
              message: 'Invalid Branch',
              description: 'Only head office can have administrator or supervisor role.'
            })
            this.processing = false
            return
          }
          if (this.editing) {
            promise = this.$http.put(this.routeUri('hyperion.user.update', { user_hash: this.user_hash }), Object.assign(formData, { username: this.item.username }))
          } else {
            promise = this.$http.post(this.routeUri('hyperion.user.store'), formData)
          }

          promise.then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleResponseError(error.response.data.data))
            .finally(() => this.processing = false)
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Saved!',
        description: 'Data has been successfully saved!'
      })
    },
    handleResponseError(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    }
  },
  watch: {
    item: function (value) {
      this.form.getFieldDecorator('name', { initialValue: value.name })
      this.form.getFieldDecorator('username', { initialValue: value.username })
      this.form.getFieldDecorator('email', { initialValue: value.email })
      this.form.getFieldDecorator('phone_number', { initialValue: value.phone_number })
      this.form.getFieldDecorator('role', { initialValue: value.roles && value.roles[0] ? value.roles[0].id : undefined })
      this.form.getFieldDecorator('branch_code', { initialValue: value.branch_code })
      this.form.getFieldDecorator('status', { initialValue: value.status == 'active' ? true : false })
    }
  }
}
</script>
